import React from "react"
import { Box, Dialog, DialogTitle, DialogContent, IconButton } from "@material-ui/core"
import Map from "./Map"
import NCText from "../../shared/NCText"
import { CloseIcon } from "../../libs/icons"

const LocationModal = ({ open, onClose, latitude, longitude }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <NCText>Location</NCText>
          <IconButton size="small" onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent style={{ height: 500, padding: 0 }}>
        <Map
          center={{ lat: Number(latitude), lng: Number(longitude) }}
          stops={[{
            seq: 1,
            latitude: Number(latitude),
            longitude: Number(longitude),
            blueMark: true
          }]}
          zoom={15}
          zoomControl
        />
      </DialogContent>
    </Dialog>
  )
}

export default LocationModal
